import React, { useState, useEffect, useContext, useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import useSound from 'use-sound';
import QuestionswithTextField from '../QuestionswithTextField';
import { checkPremiumStatus } from '../../utils/auth';


import { Link } from 'react-router-dom';
import NewQuestionBox from '../NewQuestionBox';
import ImagewithTextField from '../ImagewithTextField';
import TexttoSpeechwithTextfield from '../TexttoSpeechwithTextfield';
import ImagewithRadio from '../ImagewithRadio';
import CorrectAnswers from '../CorrectAnswers';
import MathParser from '../MathParser';
import FeedBackPopup from './FeedBackPopup';
import MailIcon from '../../assets/images/email.png';


import Lottie from 'react-lottie';
import { default as animationData } from '../../assets/loader.json';
import Amplify, { Auth } from 'aws-amplify';
import config from '../../aws-exports';
import { UserContext } from '../UserContext';
import { SubscriptionContext } from '../../reducers/SubscriptionContext';
import { LocationContext } from '../../reducers/LocationContext';
import DrawShapeswithTextField from './DrawShapeswithTextField';
import TexttoSpeechwithRadioButton from "../../components/TexttoSpeechwithRadioButton";
import { isAnswerCorrect } from '../../utils/answerUtils';

import { withAuthenticator } from 'aws-amplify-react';
import Timer from '../Timer';
import { CountdownCircleTimer } from 'react-countdown-circle-timer';

import { default as animationData1 } from '../../assets/congratulations.json';
import { default as animationData2 } from '../../assets/tryagain.json';
import { ConsoleLogger } from '@aws-amplify/core';
import { faLessThanEqual, faToiletPaper } from '@fortawesome/free-solid-svg-icons';
import { cx } from '@emotion/css';
import { button } from '../../styles/components/buttons.style';
import * as styles from '../../components/quizApp.style';
import Confetti from 'react-confetti';
import MapwithRadio from '../MapwithRadio';
import ListenSpeech from '../ListenSpeech';
import ImagesasOptions from '../ImagesasOptions';

Amplify.configure(config);

function PracticeQuiz(props) {
  const history = useHistory();
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const { subscriptionStatus } = useContext(SubscriptionContext);

  // Track if this is the first mount
  const firstMount = React.useRef(true);

  // Track if we've already incremented the attempt counter for this session
  const attemptIncremented = React.useRef(false);

  // Function to end the current practice session
  const endPracticeSession = async () => {
    try {
      const [username] = await getToken();
      if (username) {
        const sessionData = JSON.parse(sessionStorage.getItem(PRACTICE_SESSION_KEY) || '{}');
        if (sessionData.username === username) {
          sessionStorage.removeItem(PRACTICE_SESSION_KEY);
          console.log('Practice session ended properly');
        }
      }
    } catch (error) {
      console.error('Error ending practice session:', error);
    }
  };

  // Initialize quiz when component mounts
  // Function to handle beforeunload event
  const handleBeforeUnload = (e) => {
    // Only show warning if there's an active practice session
    const activeSession = JSON.parse(sessionStorage.getItem(PRACTICE_SESSION_KEY) || '{}');
    if (activeSession.active) {
      e.preventDefault();
      e.returnValue = 'Are you sure you want to leave? Your practice attempt may be counted.';
      return e.returnValue;
    }
  };

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();
    const signal = controller.signal;

    // Add event listeners
    window.addEventListener('beforeunload', handleBeforeUnload);

    const initializeQuiz = async () => {
      try {
        console.log('Initializing quiz...');
        const [username, jwt] = await getToken();
        if (!username) {
          console.log('No username found');
          return;
        }

        // Check if user is premium
        const { isPremium } = await checkPremiumStatus();
        if (isPremium) {
          console.log('Premium user, no practice limits');
          setIsPremiumUser(true);
          // Clear any existing practice session for premium users
          sessionStorage.removeItem(PRACTICE_SESSION_KEY);
          
          if (location.state?.isDailyReview) {
            console.log('Directly loading Daily SpellBowl Review for premium user');
            setIsLoading(false);
            playagain(true);
            return;
          }
          
          setIsLoading(false);
          return;
        }

        // Check for active practice session
        const activeSession = JSON.parse(sessionStorage.getItem(PRACTICE_SESSION_KEY) || '{}');
        if (activeSession.username === username && activeSession.active) {
          console.log('Resuming active practice session');
          setIsLoading(false);
          return;
        }

        // Get current practice count
        const sessionPracticeData = JSON.parse(sessionStorage.getItem(PRACTICE_ATTEMPTS_KEY) || '{}');
        const practiceCount = sessionPracticeData[username] || 0;

        console.log(`Practice attempts for ${username}:`, practiceCount);

        // For non-first attempts, check limits
        if (practiceCount > 0) {
          console.log('Subsequent attempt - checking limits');
          const { allowed } = await checkPracticeLimits();
          if (!allowed) {
            console.log('Practice not allowed, redirecting to subscription');
            return;
          }
        } else {
          // Start a new practice session for first attempt
          sessionStorage.setItem(PRACTICE_SESSION_KEY, JSON.stringify({
            username,
            active: true,
            startTime: new Date().toISOString(),
            path: location.pathname
          }));
        }

        // If we get here, practice is allowed
        console.log('Loading quiz content...');
        
        if (location.state?.isDailyReview) {
          console.log('Directly loading Daily SpellBowl Review for non-premium user');
          setIsLoading(false);
          // Pass overridePremium=true here since we already verified they are allowed to practice today
          playagain(true); 
          return;
        }

      } catch (err) {
        console.error('Error initializing quiz:', err);
        if (isMounted) {
          setError('Failed to initialize quiz. Please try again.');
        }
      } finally {
        if (isMounted) {
          setIsLoading(false);
        }
      }
    };

    initializeQuiz();

    // Handle component unmount
    return async () => {
      isMounted = false;

      try {
        const [username] = await getToken();
        if (username) {
          const activeSession = JSON.parse(sessionStorage.getItem(PRACTICE_SESSION_KEY) || '{}');
          
          // Clear the active session without incrementing counter
          // We only want to increment on actual submission, not on navigation away
          sessionStorage.removeItem(PRACTICE_SESSION_KEY);
        }
      } catch (error) {
        console.error('Error cleaning up practice session:', error);
      }
    };
  }, [location.pathname]); // Re-run if path changes

  const { countryCode } = useContext(LocationContext);

  const [isfbackOpen, setIsfbackOpen] = useState(false);
  var [fdback_id, set_fdback_id] = useState(0);

  const [questionBank, set_questionBank] = useState([]);
  const [score, set_score] = useState(0);
  const [attendedquestions, set_attendedquestions] = useState(0);

  const [newevent, set_newevent] = useState({});
  const incrementScore = () => set_score(score + 1);
  const [noofquestionsattended, set_noquestionsattended] = useState(0);
  const [questionnumber, set_questionnumber] = useState(1);
  const [useranswer, set_useranswer] = useState('');
  const [totalquestions, set_totalquestions] = useState(0);

  var [start_limit, set_start_limit] = useState(0);
  var [end_limit, set_end_limit] = useState(0);
  var [randomize, set_randomize] = useState(true);


  const [finished, is_finished] = useState(false);
  const [reviewed, is_reviewed] = useState(false);
  const [isNavigatingReview, setIsNavigatingReview] = useState(false);
  const [questionwithtextfield, is_questionwithtextfield] = useState(false);
  const [imagewithtextfield, is_imagewithtextfield] = useState(false);
  const [mapwithradiobuttons, is_mapwithradiobuttons] = useState(false);
  const [imagewithradio, is_imagewithradio] = useState(false);
  var dummy = 0
  var wronganswer = false
  var passed = false
  var activityusername = ''

  const [drawquestions, is_drawquestions] = useState(false);

  const [questionwithradio, is_questionwithradio] = useState(false);
  const [questionwithimages, is_questionwithimages] = useState(false);

  const [texttospeechwithtextfield, is_texttospeechwithtextfield] =
    useState(false);
  const [texttospeechwithradiobutton, is_texttospeechwithradiobutton] =
    useState(false);

  const [listenspeech, is_listenspeech] = useState(false);


  const [wrongansweredquestions, set_wrongansweredquestions] = useState([]);
  const [shortfallNotice, setShortfallNotice] = useState('');

  //const [user_answers, set_user_answers] = useState([]);
  const [user_answers_right, set_user_answers_right] = useState({});
  const [user_answers_right1, set_user_answers_right1] = useState({});
  const [event_activity_answers, set_event_activity_answers] = useState({});
  const [real_answers, set_real_answers] = useState({});

  const [case_checker, set_case_checker] = useState({});


  // const [jwt_token, set_jwt_token] = useState({});
  const [username, set_username] = useState({});
  const [email, set_email] = useState({});

  const [hasUsedCorrectMistakes, setHasUsedCorrectMistakes] = useState(false);
  const [isPremiumUser, setIsPremiumUser] = useState(false);
  const [isLoadingMistakes, setIsLoadingMistakes] = useState(false);
  const [questionStartTime, setQuestionStartTime] = useState(Date.now());
  const [timeTakenMap, setTimeTakenMap] = useState({});
  const [showEmptyReviewQueue, setShowEmptyReviewQueue] = useState(false);

  const [presentquestion, set_presentquestion] = useState({
    answers: (4)[('Italy', 'Russia', 'USA', 'Germany')],
    attempts: 0,
    category: 'Sports',
    correctanswer: 'Russia',
    failures: 0,
    id: 0,
    level: 3,
    question: 'Which country hosted 2014 Winter Olympics?',
    specificcategory: 'Olympics',
    subcategory: 'Sports',
  });
  const { user } = useContext(UserContext);
  let data1 = useLocation();
  //Add memo for optmize question loading
  // const [questionBank, set_questionBank] = useState([]);

  const optimizedQuestionBank = useMemo(() => {
    return questionBank.map((question, index) => {
      // Perform any expensive computation here
      return {
        ...question,
        index,
      };
    });
  }, [questionBank]);

  function togglePopup() {


    setIsOpen(!isOpen);
  }

  function togglePopupwithId(id) {

    setIsfbackOpen(!isfbackOpen);
    set_fdback_id(id)

  }



  const [playActive] = useSound(
    '../assets/pop.mp3',
    { volume: 0.25 }
  );

  const [playNext] = useSound(
    '../assets/nextorback.mp3',
    { volume: 0.25 }
  );



  const [playPass] = useSound(
    '../assets/pass.mp3',
    { volume: 0.50 }
  );

  const [playFail] = useSound(
    '../assets/fail.mp3',
    { volume: 0.25 }
  );

  const [playTick] = useSound(
    '../assets/tick.mp3',
    { volume: 0.50 }
  );


  const getToken = async () => {
    try {
      const user = await Auth.currentAuthenticatedUser();
      const session = await Auth.currentSession();
      const jwt = session.getIdToken().getJwtToken();
      const username = user.username.includes("Google_")
        ? user.attributes.email
        : user.username;
      return [username, jwt];
    } catch {
      return [null, null];
    }
  };

  // Track practice attempts in session storage
  const PRACTICE_ATTEMPTS_KEY = 'practiceAttempts';
  const PRACTICE_SESSION_KEY = 'practiceSession';
  const MAX_FREE_ATTEMPTS = 1; // Limit to 1 practice per session for free users

  const checkPracticeLimits = async () => {
    try {
      console.log('Checking practice limits...');
      const [username, jwt] = await getToken();

      // If we can't get user info, allow access to prevent blocking
      if (!username || !jwt) {
        console.log('No user session found, allowing access');
        return { allowed: true, isPremium: false };
      }

      // Check if user is premium
      const { isPremium } = await checkPremiumStatus();
      if (isPremium) {
        console.log('Premium user, no practice limits');
        // Clear any existing practice session for premium users
        sessionStorage.removeItem(PRACTICE_SESSION_KEY);
        return { allowed: true, isPremium: true };
      }

      // Check for active practice session
      const activeSession = JSON.parse(sessionStorage.getItem(PRACTICE_SESSION_KEY) || '{}');
      if (activeSession.username === username && activeSession.active) {
        console.log('Active practice session found, allowing access');
        return { allowed: true, isPremium: false };
      }

      // Get current practice count
      const sessionPracticeData = JSON.parse(sessionStorage.getItem(PRACTICE_ATTEMPTS_KEY) || '{}');
      const practiceCount = sessionPracticeData[username] || 0;

      console.log(`Practice attempts for ${username}:`, practiceCount);

      // If this is the first attempt, allow it and start a new session
      if (practiceCount === 0) {
        console.log('First attempt - starting new practice session');
        // Mark the start of a practice session
        sessionStorage.setItem(PRACTICE_SESSION_KEY, JSON.stringify({
          username,
          active: true,
          startTime: new Date().toISOString(),
          path: location.pathname
        }));
        return { allowed: true, isPremium: false };
      }

      // For second or subsequent attempts, show subscription prompt
      console.log('Subsequent attempt - showing subscription prompt');
      if (!window.location.pathname.includes('subscription')) {
        history.push({
          pathname: '/subscription',
          state: {
            message: 'You have used your free practice attempt. Upgrade to premium for unlimited practice!',
            from: window.location.pathname
          }
        });
      }
      return { allowed: false, isPremium: false };

    } catch (error) {
      console.error('Error in checkPracticeLimits:', error);
      // On error, allow access to prevent blocking users
      return { allowed: true, isPremium: false, error: true };
    }
  };

  let answ = [];

  const updateEventyActivity = async (updatedscore) => {
    if (!questionBank || questionBank.length === 0) return;

    let eventanswermap = {};
    let wronganswers = [];
    const userAnswers = user_answers_right || {};
    const answers = real_answers || {};
    const answ = [];
    let passed = false;

    // Process each question in the question bank
    questionBank.forEach((question, index) => {
      const questionId = question.id;
      const userAnswer = userAnswers[questionId];
      const correctAnswer = question.correctanswer;
      let isWrong = false;

      // Format question text based on type
      const questionText = imagewithtextfield
        ? `<img src="${question.question}" height="100px" width="100px" />`
        : question.question;

      // Store question and answer information
      answ[index] = `Q: ${index} Question: ${questionText} ` +
        `Correct Answer: ${correctAnswer} ` +
        `Your selection: ${userAnswer || 'Not answered'}`;

      // Check if answer is wrong or not provided
      if (!userAnswer) {
        isWrong = true;
      } else {
        const correctAnswers = answers[questionId] && answers[questionId].length > 0
          ? answers[questionId]
          : [String(correctAnswer || '')];

        const ignoreCases = case_checker[questionId] !== undefined 
          ? case_checker[questionId] 
          : (question.ignorecases !== undefined ? question.ignorecases : 'true');

        isWrong = !isAnswerCorrect(userAnswer, correctAnswers, ignoreCases, question.category || data1.state?.category);
      }

      // Track wrong answers
      if (isWrong) {
        wronganswers.push(question);
      }

      // Map correct answer to user's answer
      eventanswermap[correctAnswer] = userAnswer || '';
    });

    // Update state with wrong answers
    if (wronganswers.length > 0) {
      set_presentquestion(wronganswers[0]);
    }
    set_wrongansweredquestions(wronganswers);

    // Check if user passed
    passed = updatedscore >= questionBank.length;

    try {
      // Get current authenticated user
      const user = await Auth.currentAuthenticatedUser();
      const username = user.username.includes("Google_")
        ? user.attributes['email']
        : user.username;

      // Gather question metrics
      const questionMetrics = questionBank.map(q => ({
        questionId: q.id,
        isCorrect: isAnswerCorrect(
          userAnswers[q.id], 
          answers[q.id] && answers[q.id].length > 0 ? answers[q.id] : [q.correctanswer], 
          case_checker[q.id] !== undefined ? case_checker[q.id] : (q.ignorecases !== undefined ? q.ignorecases : 'true'), 
          q.category || data1.state?.category
        ),
        timeTaken: timeTakenMap[q.id] || 10
      }));

      // Prepare request data
      const requestData = {
        eventid: data1.state?.id || '',
        eventname: data1.state?.name || 'Practice Quiz',
        username: username,
        score: updatedscore,
        timetaken: 10, // Default time taken
        targetscore: questionBank.length,
        level: (data1.state?.level || '').replace('Grade', ''),
        passed: passed,
        operation: 'practice',
        description: data1.state?.name || 'Practice Quiz',
        emailid: email || '',
        category: data1.state?.category || 'general',
        correctanswers: answ,
        eventtype: 'practice',
        qualificationno: questionBank.length,
        emailtobesend: data1.state?.sendEmail || false,
        eventemailid: data1.state?.email || 'email',
        useranswers: eventanswermap,
        questionMetrics: questionMetrics,
      };

      // Send data to API
      const response = await fetch(
        'https://api.quizwizard.net/quiz/updatepracticeactivity',
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(requestData),
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const responseData = await response.json();
      console.log('Activity updated:', responseData);

    } catch (error) {
      console.error('Error updating activity:', error);
    } finally {
      is_finished(true);
    }
  };

  useEffect(() => {
    // Check if user is premium when component mounts
    const checkPremium = async () => {
      try {
        const { isPremium } = await checkPremiumStatus();
        setIsPremiumUser(isPremium);
      } catch (error) {
        console.error('Error checking premium status:', error);
      }
    };

    checkPremium();
  }, []);

  // Number of questions with a saved answer — recalculate this fresh every
  // time the review summary screen is shown, since answers can change while
  // stepping through review-navigation (see isNavigatingReview branches in
  // selectedanswers/backanswers) after the count was first taken.
  function countAttendedQuestions() {
    return Object.values(user_answers_right).filter(
      (answer) => answer !== undefined && answer !== null && String(answer).trim() !== ''
    ).length;
  }

  async function reviewscreen() {
    is_reviewed(true);
    setIsNavigatingReview(false);

    // End the practice session when user finishes the quiz
    await endPracticeSession();

    const count = countAttendedQuestions();





    set_attendedquestions(count);
  }

  function ReviewAnswers(questno) {
    const questionToReview = questionBank[questno];
    is_reviewed(false); // Show the question component, not the review table
    setIsNavigatingReview(true); // Enter review navigation mode
    set_presentquestion(questionToReview);
    set_questionnumber(questno + 1); // questno is 0-indexed, so +1 is correct for display
    updateQuestionTypeState(questionToReview.displayformat);
  }

  // Function to handle playing the quiz again with review questions
  async function playagain(overridePremium = false, isRetry = false) {
    try {
      setIsLoadingMistakes(true);
      
      // If user is not premium, redirect to subscription immediately
      if (!isPremiumUser && !overridePremium) {
        history.push('/subscription');
        return;
      }

      let reviewQuestions = [];

      // If Daily SpellBowl Review was launched and it is NOT a retry, fetch from API
      if (data1.state?.isDailyReview && !isRetry) {
        const user = await Auth.currentAuthenticatedUser();
        const session = await Auth.currentSession();
        const jwt = session.getAccessToken().getJwtToken();
        const username = user.username.includes("Google_") ? user.attributes['email'] : user.username;
        const level = String(data1.state?.level || '').replace('Grade', '');

        const response = await fetch('https://api.quizwizard.net/quiz/get_review_queue', {
          method: 'POST',
          headers: { 
            'Content-Type': 'application/json',
            'Authorization': jwt
          },
          body: JSON.stringify({ 
            username, 
            level, 
            category: 'SpellBowl',
            reviewType: data1.state?.reviewType || 'spaced_repetition',
            reviewDays: data1.state?.reviewDays,
            days: data1.state?.reviewDays,
            review_days: data1.state?.reviewDays,
            questionLimit: data1.state?.reviewQuestionLimit || 15,
            startLimit: data1.state?.reviewStartLimit || 1
          })
        });

        if (response.ok) {
          const data = await response.json();
          reviewQuestions = data.questions || [];
        }

        if (reviewQuestions.length === 0) {
          setShowEmptyReviewQueue(true);
          setIsLoadingMistakes(false);
          return; // Stop execution to show empty state UI
        } else if (reviewQuestions.length < (data1.state?.reviewQuestionLimit || 15)) {
          setShortfallNotice(`Note: You only had ${reviewQuestions.length} words due for review!`);
          setTimeout(() => setShortfallNotice(''), 5000);
        } else {
          setShortfallNotice('');
        }
      } else {
        // Correct Mistakes logic (fallback or retry)
        reviewQuestions = [...wrongansweredquestions];
        
        if (reviewQuestions.length === 0) {
          alert('No missed words to review!');
          setIsLoadingMistakes(false);
          return;
        }
      }
      
      // Shuffle questions if randomize is enabled
      if (data1.state?.randomize !== false) {
        reviewQuestions = [...reviewQuestions].sort(() => Math.random() - 0.5);
      }
      
      // Batch all state updates together
      await Promise.all([
        // Reset states
        new Promise(resolve => {
          is_finished(false);
          setShowEmptyReviewQueue(false);
          is_reviewed(false);
          set_score(0);
          set_questionnumber(1);
          set_noquestionsattended(0);
          set_attendedquestions(0);
          setQuestionStartTime(Date.now());
          setTimeTakenMap({});
          
          // Reset all question type states
          is_imagewithtextfield(false);
          is_mapwithradiobuttons(false);
          is_imagewithradio(false);
          is_texttospeechwithtextfield(false);
          is_listenspeech(false);
          is_texttospeechwithradiobutton(false);
          is_drawquestions(false);
          is_questionwithradio(false);
          is_questionwithimages(false);
          is_questionwithtextfield(false);
          
          // Reset user answers
          set_user_answers_right1({});
          set_user_answers_right({});
          resolve();
        })
      ]);

      // Set the new question bank with review questions
      let dict_answer = {};
      let case_checkercondition = {};
      
      reviewQuestions.forEach(q => {
        let newaary = [q.correctanswer];
        if (q.alternateanswerlist && q.alternateanswerlist.length > 0) {
          newaary = q.alternateanswerlist.concat(q.correctanswer);
        }
        dict_answer[q.id] = newaary;
        case_checkercondition[q.id] = q.ignorecases;
      });
      
      set_real_answers(dict_answer);
      set_case_checker(case_checkercondition);

      set_questionBank(reviewQuestions);
      set_totalquestions(reviewQuestions.length);
      setHasUsedCorrectMistakes(true);
      
      // Set the first question if there are any
      if (reviewQuestions.length > 0) {
        const firstQuestion = reviewQuestions[0];
        set_presentquestion(firstQuestion);
        updateQuestionTypeState(firstQuestion.displayformat);
        
        // Set the appropriate question type
        const questionTypeSetters = {
          'ImagewithRadio': () => is_imagewithradio(true),
          'SpeakTextwithTextField': () => is_texttospeechwithtextfield(true),
          'ListenSpeech': () => is_listenspeech(true),
          'SpeakTextwithRadioButton': () => is_texttospeechwithradiobutton(true),
          'QuestionswithTextField': () => is_questionwithtextfield(true),
          'MapwithRadioButtons': () => is_mapwithradiobuttons(true),
          'QuestionswithImages': () => is_questionwithimages(true),
          'drawquestions': () => is_drawquestions(true)
        };

        const setQuestionType = questionTypeSetters[firstQuestion.displayformat] || (() => is_questionwithradio(true));
        setQuestionType();
      }
    } catch (error) {
      console.error('Error in playagain:', error);
      alert('Failed to load review questions. Please try again.');
    } finally {
      setIsLoadingMistakes(false);
    }
  }

  const updateUserScore = async (updatedscore) => {
    let newscore = 0;
    if (updatedscore >= totalquestions) {
      newscore = user['score'] + data1.state['points'];
      user['score'] = newscore;
    } else {
      newscore = user['score'] - data1.state['points'];
      user['score'] = newscore;
    }
  };

  // const updateUserScore = async (jwt, updatedscore) => {
  //   let newscore = 0;
  //   if (updatedscore >= totalquestions) {
  //     newscore = user['score'] + data1.state['points'];
  //     user['score'] = newscore;
  //   }
  //   else {
  //     newscore = user['score'] - data1.state['points'];
  //     user['score'] = newscore;
  //   }
  // };

  const getQuestionfromDB = async () => {
    if (data1.state?.isDailyReview) return;
    
    const specificcategory = data1.state['specificcategory'];

    const level1 = data1.state['levels'];
    const limits = data1.state['limits'];
    const eventdisplay = data1.state['eventdisplay'];

    start_limit = data1.state['start_limit'];
    end_limit = data1.state['end_limit'];
    randomize = data1.state['randomize'];


    if (randomize == undefined) {

      randomize = true
    }



    if (start_limit == undefined || end_limit == undefined) {
      start_limit = 0
      end_limit = data1.state['totalquestions'] - 1;
    }

    set_totalquestions(end_limit - start_limit + 1)


    const questions = data1.state['questions'];



    var specificcategoryreplace = ('' + specificcategory).replace(/%20/g, ' ');



    var questionno;
    let dict_answer = real_answers;
    let case_checkercondition = [];
    let requiredquestionarray = [];
    let correctanswerarray = [];
    let newaary = []

    for (questionno in questions) {




      correctanswerarray = [];
      newaary = []


      if (Number(questionno) >= start_limit && Number(questionno) <= end_limit) {
        newaary = [questions[questionno].correctanswer];
        if ("alternateanswerlist" in questions[questionno]) {
          if (questions[questionno].alternateanswerlist.length > 0) {
            newaary = questions[questionno].alternateanswerlist.concat(questions[questionno].correctanswer)
          }
        }

        dict_answer[questions[questionno].id] = newaary;

        case_checkercondition[questions[questionno].id] =
          questions[questionno].ignorecases;

        requiredquestionarray[questionno] = questions[questionno];
      }
    }

    set_real_answers(dict_answer);
    set_case_checker(case_checkercondition);


    // Filter out undefined slots from the sparse array (e.g. when start_limit > 0,
    // indices 0..start_limit-1 are empty and expand to `undefined` after spread).
    // Destructuring undefined items in the results map would crash the render tree.
    const compactArray = requiredquestionarray.filter(Boolean);

    if (randomize) {
      compactArray.sort(() => Math.random() - 0.5);
    }

    set_questionBank(compactArray);


    set_presentquestion(compactArray[0]);

    var displayformat = compactArray[0]["displayformat"]


    if (displayformat == 'ImagewithTextField') {
      is_imagewithtextfield(true);

    } else if (displayformat == 'ImagewithRadio') {
      is_imagewithradio(true);
    } else if (displayformat == 'SpeakTextwithTextField') {
      is_texttospeechwithtextfield(true);

    }
    else if (displayformat == 'ListenSpeech') {
      is_listenspeech(true);

    }

    else if (displayformat == 'SpeakTextwithRadioButton') {
      is_texttospeechwithradiobutton(true);

    }

    else if (displayformat == 'QuestionswithTextField') {
      is_questionwithtextfield(true);
    }
    else if (displayformat == 'drawquestions') {
      is_drawquestions(true);
    }
    else if (displayformat == 'MapwithRadioButtons') {
      is_mapwithradiobuttons(true)

    }
    else if (displayformat == 'QuestionswithImages') {
      // console.log("Setting is_mapwithradiobuttons ")
      is_questionwithimages(true);

    }

    else {
      is_questionwithradio(true);
    }



  };

  function closeFeedBack() {
    ////console.log("REached parent screen")


    setIsOpen(!isOpen);
    // set_batches([{}]);
    // getToken();
  }

  function closeFeedBackNew() {
    ////console.log("REached parent screen")

    setIsfbackOpen(!isfbackOpen)

  }


  function computeAnswer(answer, id) {

    playActive()

    let useranswermap = user_answers_right;
    useranswermap[id] = answer;

    set_user_answers_right(useranswermap);
    //////console.log(user_answers_right)
  }

  const getPracticeLimitDetails = async (username, jwt) => {
    try {
      // First check premium status
      const { isPremium } = await checkPremiumStatus();
      if (isPremium) {
        console.log('Premium user - practice limits do not apply');
        return true; // Skip practice limits for premium users
      }

      // For non-premium users, check practice limits
      console.log('Checking practice limits for user:', username);
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: jwt
        },
        body: JSON.stringify({
          username,
          source: 'quiz',
          timestamp: new Date().toISOString() // Add timestamp for debugging
        })
      };

      console.log('Sending request to check practice limit...');
      const startTime = Date.now();
      const response = await fetch('https://api.quizwizard.net/check-practice-limit', requestOptions);
      const responseTime = Date.now() - startTime;

      console.log(`Practice limit check took ${responseTime}ms`);

      if (!response.ok) {
        const errorText = await response.text();
        console.error('Error response from server:', {
          status: response.status,
          statusText: response.statusText,
          responseText: errorText
        });
        return true; // If there's an error, allow access to prevent blocking users
      }

      const data = await response.json();
      console.log('Practice limit API response:', JSON.stringify(data, null, 2));

      // If the response doesn't have practiceAllowed, assume unlimited access
      if (data.practiceAllowed === undefined) {
        console.warn('No practiceAllowed in response, defaulting to unlimited access. Full response:', data);
        return true;
      }

      console.log(`Practice allowed: ${data.practiceAllowed}`);
      return data.practiceAllowed === true; // Ensure boolean return

    } catch (error) {
      console.error('Error checking practice limits:', {
        message: error.message,
        stack: error.stack,
        name: error.name
      });
      return true; // On error, allow access to prevent blocking users
    }
  };

const confirmanswers = async () => {
  is_finished(true);
  is_reviewed(false);

  let actualScore = 0;

  // Process answers for scoring
  Object.entries(user_answers_right).forEach(([key, val]) => {
    if (real_answers && real_answers[key]) {
      const q = questionBank.find(q => String(q.id) === String(key));
      const category = q ? q.category : '';
      const ignoreCases = case_checker[key] !== undefined ? case_checker[key] : 'true';
      
      if (isAnswerCorrect(val, real_answers[key], ignoreCases, category)) {
        actualScore += 1;
      }
    }
  });

  set_score(actualScore);
  is_finished(true);

  if (actualScore >= totalquestions) {
    playPass();
  } else {
    playFail();
  }

  // Update user activity
  updateEventyActivity(actualScore);

  // Increment practice attempt counter only on submission
  try {
    const [username] = await getToken();
    if (username) {
      const sessionPracticeData = JSON.parse(sessionStorage.getItem(PRACTICE_ATTEMPTS_KEY) || '{}');
      const practiceCount = sessionPracticeData[username] || 0;
      
      // Only increment if this is the first submission
      if (practiceCount === 0) {
        console.log('Incrementing practice attempt counter on submission');
        sessionStorage.setItem(PRACTICE_ATTEMPTS_KEY,
          JSON.stringify({
            ...sessionPracticeData,
            [username]: 1
          })
        );
        
        // End the practice session
        sessionStorage.removeItem(PRACTICE_SESSION_KEY);
      }
    }
  } catch (error) {
    console.error('Error updating practice attempt counter:', error);
  }
};

const updateQuestionTypeState = (type) => {
  // Reset all question type states
  is_imagewithtextfield(false);
  is_imagewithradio(false);
  is_texttospeechwithtextfield(false);
  is_listenspeech(false);
  is_texttospeechwithradiobutton(false);
  is_drawquestions(false);
  is_questionwithradio(false);
  is_questionwithimages(false);
  is_mapwithradiobuttons(false);
  is_questionwithtextfield(false);

  // Set the active question type
  switch (type) {
    case 'ImagewithTextField':
      return is_imagewithtextfield(true);
    case 'ImagewithRadio':
      return is_imagewithradio(true);
    case 'SpeakTextwithTextField':
      return is_texttospeechwithtextfield(true);
    case 'ListenSpeech':
      return is_listenspeech(true);
    case 'SpeakTextwithRadioButton':
      return is_texttospeechwithradiobutton(true);
    case 'QuestionswithTextField':
      return is_questionwithtextfield(true);
    case 'MapwithRadioButtons':
      return is_mapwithradiobuttons(true);
    case 'drawquestions':
      return is_drawquestions(true);
    case 'QuestionswithImages':
      return is_questionwithimages(true);
    default:
      return is_questionwithradio(true);
  }
};

const selectedanswers = () => {
  playNext();
  
  if (presentquestion && presentquestion.id) {
    const timeTaken = Math.floor((Date.now() - questionStartTime) / 1000);
    setTimeTakenMap(prev => ({ ...prev, [presentquestion.id]: timeTaken }));
    setQuestionStartTime(Date.now());
  }


  if (isNavigatingReview) {
    const currentIndex = questionBank.findIndex(q => q.id === presentquestion.id);
    if (currentIndex < questionBank.length - 1) {
      const nextQuestion = questionBank[currentIndex + 1];
      set_presentquestion(nextQuestion);
      set_questionnumber(currentIndex + 2);
      updateQuestionTypeState(nextQuestion.displayformat);
    } else {
      // At the last question, go back to the review summary screen
      is_reviewed(true);
      setIsNavigatingReview(false);
      set_attendedquestions(countAttendedQuestions());
    }
  } else if (noofquestionsattended + 1 < totalquestions) {
    const nextQuestionIndex = noofquestionsattended + 1;
    const nextQuestion = optimizedQuestionBank[nextQuestionIndex];

    set_questionnumber(questionnumber + 1);
    set_presentquestion(nextQuestion);
    updateQuestionTypeState(nextQuestion.displayformat);
    set_noquestionsattended(noofquestionsattended + 1);
    set_user_answers_right1(user_answers_right);
  } else if (noofquestionsattended + 1 === totalquestions) {
    is_reviewed(true);
    set_attendedquestions(countAttendedQuestions());
  } else {
    let actualScore = 0;
    var key, val;
    for ([key, val] of Object.entries(user_answers_right)) {
      const q = questionBank.find(q => String(q.id) === String(key));
      const category = q ? q.category : '';
      const ignoreCases = case_checker[key] !== undefined ? case_checker[key] : 'true';
      
      if (isAnswerCorrect(val, real_answers[key], ignoreCases, category)) {
        actualScore += 1;
      }
    }
    set_score(actualScore);
    is_finished(true);

    if (actualScore >= totalquestions) {
      playPass();
    } else {
      playFail();
    }
  }
};
  function handleCallback(childData) {
    confirmanswers()
  }

  const backanswers = () => {
    playNext();

    if (isNavigatingReview) {
      const currentIndex = questionBank.findIndex(q => q.id === presentquestion.id);
      if (currentIndex > 0) {
        const prevQuestion = questionBank[currentIndex - 1];
        set_presentquestion(prevQuestion);
        set_questionnumber(currentIndex); // question number is index + 1, so this is correct
        updateQuestionTypeState(prevQuestion.displayformat);
      } else {
        // At the first question, go back to the review summary screen
        is_reviewed(true);
        setIsNavigatingReview(false);
        set_attendedquestions(countAttendedQuestions());
      }
    } else if (reviewed) {
      // Leaving the review summary screen: noofquestionsattended already
      // points at the last question that was on screen, so just show that
      // question again instead of stepping one further back.
      const prevQuestion = optimizedQuestionBank[noofquestionsattended];

      is_reviewed(false);
      set_questionnumber(noofquestionsattended + 1);
      set_presentquestion(prevQuestion);
      updateQuestionTypeState(prevQuestion.displayformat);
    } else if (noofquestionsattended > 0) {
      // Handle normal back navigation during quiz
      const prevQuestionIndex = noofquestionsattended - 1;
      const prevQuestion = optimizedQuestionBank[prevQuestionIndex];

      set_questionnumber(prev => prev - 1);
      set_presentquestion(prevQuestion);
      updateQuestionTypeState(prevQuestion.displayformat);
      set_noquestionsattended(prevQuestionIndex);
    }
  };

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  const congratsOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData1,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  const tryagainOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData2,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();

    getQuestionfromDB();

    const totalquestions = data1.state['totalquestions'];
    document.title = 'Practice Quiz';

    // Cleanup function
    return () => {
      isMounted = false;
      controller.abort(); // Abort any ongoing fetch requests
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [location.pathname]); // Re-run if path changes

  const controlButtons = (
    <div className={!finished && cx(styles.buttonGroup_review)}>
      {presentquestion.id > 0 && finished == false ? (
        <button key="Back1" onClick={backanswers}>
          Back
        </button>
      ) : null}






      {reviewed == false && !finished ? (
        <button key="ReviewScreen" onClick={reviewscreen}>
          Review
        </button>
      ) : null}

      {reviewed == true && !finished ? (
        <button key="ConfirmScreen" onClick={confirmanswers}>
          Submit Answers
        </button>
      ) : ""}




      {presentquestion.id > 0 && finished == false && !reviewed ? (
        <button key="Next1" onClick={selectedanswers}>
          Next
        </button>
      ) : null}



    </div>

  );




  return (
    <div>
      {finished &&
        score >= totalquestions && (
          <div className={styles.overflowXHidden}>
            <Confetti />
          </div>
        )}

      <div>
        <div
          className={`${finished ? 'no-shadow inner ' : ''}${cx(
            styles.container
          )}`}
        >
          {showEmptyReviewQueue ? (
            <div style={{
              background: 'linear-gradient(135deg, #ffffff 0%, #f0fdf4 100%)',
              border: '2px solid rgba(34, 197, 94, 0.15)',
              borderRadius: '24px',
              padding: '3rem 2rem',
              boxShadow: '0 20px 50px rgba(34, 197, 94, 0.06)',
              textAlign: 'center',
              marginBottom: '2rem',
            }}>
              <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>🎉</div>
              <h2 style={{ fontSize: '2.2rem', fontWeight: '800', color: '#166534', margin: '0 0 0.4rem' }}>
                You're all caught up!
              </h2>
              <p style={{ fontSize: '1rem', color: '#15803d', margin: '0 0 1.2rem', fontWeight: '500' }}>
                You have no pending missed words to review. Here are some great ways to keep learning:
              </p>
              <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}>
                <button className={cx(button)} onClick={() => window.location.reload()}>Start Mixed Practice</button>
                <Link to="/practiceevents"><button className={cx(button)}>Try a Challenge Quiz</button></Link>
                <button className={cx(button)} onClick={() => {
                  // Fallback to reviewing recently mastered
                  setShowEmptyReviewQueue(false);
                  set_questionBank(wrongansweredquestions); 
                  set_totalquestions(wrongansweredquestions.length);
                  set_presentquestion(wrongansweredquestions[0]);
                }}>Review Mastered Concepts</button>
              </div>
            </div>
          ) : finished && score < totalquestions ? (
            <div style={{
              background: 'linear-gradient(135deg, #ffffff 0%, #fff8f5 100%)',
              border: '2px solid rgba(241, 102, 2, 0.15)',
              borderRadius: '24px',
              padding: '3rem 2rem',
              boxShadow: '0 20px 50px rgba(241, 102, 2, 0.06)',
              textAlign: 'center',
              marginBottom: '2rem',
              position: 'relative',
              overflow: 'hidden'
            }}>
              <style>{`
                @keyframes popInResult {
                  0% { opacity: 0; transform: scale(0.5); }
                  70% { transform: scale(1.1); }
                  100% { opacity: 1; transform: scale(1); }
                }
              `}</style>
              <div style={{ position: 'absolute', top: '-40px', right: '-40px', width: '130px', height: '130px', background: 'radial-gradient(circle, rgba(241,102,2,0.08) 0%, transparent 70%)', borderRadius: '50%' }} />
              <div style={{ position: 'absolute', bottom: '-40px', left: '-40px', width: '130px', height: '130px', background: 'radial-gradient(circle, rgba(241,102,2,0.06) 0%, transparent 70%)', borderRadius: '50%' }} />
              <div style={{
                width: '90px', height: '90px', margin: '0 auto 1.5rem',
                background: 'linear-gradient(135deg, #ff6b35 0%, #f16602 100%)',
                borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center',
                boxShadow: '0 10px 25px rgba(241,102,2,0.25)',
                animation: 'popInResult 0.6s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards',
                fontSize: '2.2rem'
              }}>💪</div>
              <h2 style={{ fontSize: '2.2rem', fontWeight: '800', color: '#382110', margin: '0 0 0.4rem', letterSpacing: '-0.02em', fontFamily: "'Outfit', 'Inter', sans-serif" }}>
                Keep <span style={{ color: '#f16602' }}>Practicing!</span>
              </h2>
              <p style={{ fontSize: '1rem', color: '#6b574a', margin: '0 0 1.2rem', fontWeight: '500', fontFamily: "'Inter', sans-serif" }}>
                You scored {score} out of {totalquestions}. Review your answers below and try again!
              </p>
              <div style={{
                display: 'inline-flex', gap: '2.5rem',
                background: 'rgba(241,102,2,0.06)', borderRadius: '16px', padding: '1rem 2rem',
                border: '1px solid rgba(241,102,2,0.12)'
              }}>
                <div style={{ textAlign: 'center' }}>
                  <div style={{ fontSize: '1.8rem', fontWeight: '800', color: '#2ec32b' }}>{score}</div>
                  <div style={{ fontSize: '0.72rem', fontWeight: '700', color: '#594436', textTransform: 'uppercase', letterSpacing: '0.08em' }}>Correct</div>
                </div>
                <div style={{ width: '1px', background: 'rgba(241,102,2,0.15)' }} />
                <div style={{ textAlign: 'center' }}>
                  <div style={{ fontSize: '1.8rem', fontWeight: '800', color: '#c32b2b' }}>{totalquestions - score}</div>
                  <div style={{ fontSize: '0.72rem', fontWeight: '700', color: '#594436', textTransform: 'uppercase', letterSpacing: '0.08em' }}>Wrong</div>
                </div>
                <div style={{ width: '1px', background: 'rgba(241,102,2,0.15)' }} />
                <div style={{ textAlign: 'center' }}>
                  <div style={{ fontSize: '1.8rem', fontWeight: '800', color: '#f16602' }}>{Math.floor((score / totalquestions) * 100)}%</div>
                  <div style={{ fontSize: '0.72rem', fontWeight: '700', color: '#594436', textTransform: 'uppercase', letterSpacing: '0.08em' }}>Score</div>
                </div>
              </div>
            </div>
          ) : (
            ''
          )}

          {reviewed ? (
            <div>
              {/* <img
                className={cx(styles.img)}
                src={require('../../assets/images/oops.jpeg').default}
                alt=""
              /> */}
              <p className={`text-center color-black ${styles.title}`}>
                Review Answers
              </p>

            </div>
          ) : (
            ''
          )}
          
          {shortfallNotice && presentquestion.id > 0 && finished == false && reviewed == false ? (
            <div style={{
              background: '#fffbeb',
              border: '1px solid #fef3c7',
              borderRadius: '8px',
              padding: '12px 20px',
              margin: '0 auto 20px',
              maxWidth: '600px',
              color: '#92400e',
              fontSize: '0.95rem',
              fontWeight: '600',
              textAlign: 'center',
              boxShadow: '0 2px 4px rgba(245, 158, 11, 0.05)'
            }}>
              {shortfallNotice}
            </div>
          ) : null}

          {presentquestion.id > 0 && finished == false ? (
            <div className={styles.progress}>
              {questionBank.length > 0 ? (

                <>
                  <CountdownCircleTimer
                    isPlaying
                    duration={(data1.state?.time !== undefined ? data1.state.time : 60) * totalquestions}
                    colors={['#eed017']}
                    size={105}
                    strokeWidth={7}
                    onComplete={handleCallback}
                  >

                    {({ remainingTime }) => {
                      // Calculate hours, minutes, and seconds
                      const hours = Math.floor(remainingTime / 3600);
                      const minutes = Math.floor((remainingTime % 3600) / 60);
                      const seconds = remainingTime % 60;

                      // Format seconds and minutes with leading zeros
                      const formattedSeconds = seconds < 10 ? `0${seconds}` : seconds;
                      const formattedMinutes = minutes < 10 && hours > 0 ? `0${minutes}` : minutes;

                      //console.log(remainingTime % 60)
                      if (remainingTime % 60 != dummy) {
                        dummy = remainingTime % 60
                        // playTick()
                        // console.log(seconds)
                      }

                      // Display format based on duration
                      const timeDisplay = hours > 0
                        ? `${hours}:${formattedMinutes}:${formattedSeconds}`
                        : `${minutes}:${formattedSeconds}`;

                      // Label based on duration
                      const timeLabel = hours > 0 ? 'HRS' : 'MIN';

                      return (
                        <div
                          className="text-center"
                          style={{ fontSize: '17px' }}
                        >
                          {timeDisplay}
                          <br />
                          {timeLabel}
                        </div>
                      );
                    }}
                  </CountdownCircleTimer>


                </>
              ) : (
                ''
              )}{' '}
            </div>
          ) : (
            ' '
          )}
          {!finished && !reviewed &&
            <button className={cx(styles.editBtn)} onClick={togglePopup}  >
              <img src={require('../../assets/images/email.png').default} alt="" />
            </button>

          }




          {finished && score >= totalquestions ? (
            <div style={{
              background: 'linear-gradient(135deg, #ffffff 0%, #fffdfa 100%)',
              border: '2px solid rgba(241, 102, 2, 0.15)',
              borderRadius: '24px',
              padding: '3rem 2rem',
              boxShadow: '0 20px 50px rgba(241, 102, 2, 0.08)',
              textAlign: 'center',
              marginBottom: '2rem',
              position: 'relative',
              overflow: 'hidden'
            }}>
              <div style={{ position: 'absolute', top: '-50px', right: '-50px', width: '150px', height: '150px', background: 'radial-gradient(circle, rgba(241,102,2,0.1) 0%, transparent 70%)', borderRadius: '50%' }} />
              <div style={{ position: 'absolute', bottom: '-50px', left: '-50px', width: '150px', height: '150px', background: 'radial-gradient(circle, rgba(244,203,14,0.15) 0%, transparent 70%)', borderRadius: '50%' }} />
              <div style={{
                width: '90px', height: '90px', margin: '0 auto 1.5rem',
                background: 'linear-gradient(135deg, #f16602 0%, #ff9a45 100%)',
                borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center',
                boxShadow: '0 10px 25px rgba(241,102,2,0.3)',
                animation: 'popInResult 0.6s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards',
                fontSize: '2.2rem'
              }}>🏆</div>
              <h2 style={{ fontSize: '2.4rem', fontWeight: '800', color: '#382110', margin: '0 0 0.4rem', letterSpacing: '-0.02em', fontFamily: "'Outfit', 'Inter', sans-serif" }}>
                Practice <span style={{ color: '#f16602' }}>Complete!</span>
              </h2>
              <p style={{ fontSize: '1.05rem', color: '#6b574a', margin: '0 0 1.2rem', fontWeight: '500', fontFamily: "'Inter', sans-serif" }}>
                Outstanding! You scored {score} out of {totalquestions} — a perfect run!
              </p>
              <div style={{
                display: 'inline-flex', gap: '2.5rem',
                background: 'rgba(241,102,2,0.06)', borderRadius: '16px', padding: '1rem 2rem',
                border: '1px solid rgba(241,102,2,0.12)'
              }}>
                <div style={{ textAlign: 'center' }}>
                  <div style={{ fontSize: '1.8rem', fontWeight: '800', color: '#2ec32b' }}>{score}</div>
                  <div style={{ fontSize: '0.72rem', fontWeight: '700', color: '#594436', textTransform: 'uppercase', letterSpacing: '0.08em' }}>Correct</div>
                </div>
                <div style={{ width: '1px', background: 'rgba(241,102,2,0.15)' }} />
                <div style={{ textAlign: 'center' }}>
                  <div style={{ fontSize: '1.8rem', fontWeight: '800', color: '#f16602' }}>100%</div>
                  <div style={{ fontSize: '0.72rem', fontWeight: '700', color: '#594436', textTransform: 'uppercase', letterSpacing: '0.08em' }}>Score</div>
                </div>
              </div>
            </div>
          ) : (
            ''
          )}


          {isOpen && (
            <FeedBackPopup
              handleClose={togglePopup}
              eventname={data1.state['name']}
              selected={() => closeFeedBack()}
              presentquestion={presentquestion}
            />
          )}


          {isfbackOpen && (
            <FeedBackPopup
              handleClose={closeFeedBackNew}
              selected={() => closeFeedBackNew()}
              eventname={data1.state['name']}
              presentquestion={questionBank[fdback_id]}
            />
          )}



          {reviewed && (
            <div className={cx(styles.summary)}>
              <div className="item">
                <p className="s-title">{totalquestions}</p>
                <p className="sub-title">Question</p>
              </div>
              <div className="item">
                <p style={{ color: '#2ec32b' }} className="s-title">
                  {attendedquestions}
                </p>
                <p className="sub-title">Answered</p>
              </div>
              <div className="item">
                <p style={{ color: '#c32b2b' }} className="s-title">
                  {totalquestions - attendedquestions}
                </p>
                <p className="sub-title">Not Answered</p>
              </div>
              <div className="item">
                <p style={{ color: '#dd7029' }} className="s-title">
                  {Math.floor((attendedquestions / totalquestions) * 100)}%
                </p>
                <p className="sub-title">Completed</p>
              </div>
            </div>
          )}


          <div className="table-responsive">
            {reviewed ? (
              <table
                border={0}
                cellPadding={0}
                cellSpacing={0}
                className={cx(styles.table)}
              >
                <tr>
                  <th>Question </th>
                  <th>Your Answer</th>
                  <th>Review</th>
                </tr>
              </table>
            ) : (
              ''
            )}

            {reviewed &&
              data1.state['eventtype'] == 'Practice' &&
              questionBank.map(({ question, specificcategory, answers, correctanswer, meaning, id, }, index) => (
                <table
                  border={0}
                  cellPadding={0}
                  cellSpacing={0}
                  className={cx(styles.table)}
                  style={{ marginBottom: '30px' }}
                >
                  <tbody>


                    <tr>
                      <td>
                        {specificcategory?.includes("Spell Bowl") || specificcategory?.includes("Spell-it") ? (
                          index + 1 + ". " + (meaning != undefined ? meaning : "")
                        ) : (
                          <MathParser text={`${index + 1}. ${question != undefined ? question : ""}`} />
                        )}
                      </td>

                      <td>
                        <div>
                          {typeof user_answers_right[id] === 'string' && (user_answers_right[id].includes('\\') || user_answers_right[id].includes('^') || user_answers_right[id].includes('_')) ? (
                            <MathParser text={`$\\displaystyle ${user_answers_right[id]}$`} />
                          ) : (
                            <MathParser text={user_answers_right[id] ? String(user_answers_right[id]) : ''} />
                          )}
                        </div>
                      </td>

                      <td>
                        <button width="20" className={cx(button)} onClick={() => ReviewAnswers(index)}> Review Question No {index + 1}</button>
                      </td>
                    </tr>


                    {/* <ReviewAnswers
                      question={question}
                      correctanswer={

                        texttospeechwithtextfield ? correctanswer : user_answers_right[id] == correctanswer ? correctanswer : correctanswer
                        // user_answers_right[id] == correctanswer ? correctanswer : ''
                      }
                      id={id}
                      key={id}
                      selectedanswer={user_answers_right[id]}
                      eventtype={data1.state['eventdisplay']}
                    /> */}

                  </tbody>
                </table>
              ))}
          </div>

          {reviewed == true && questionwithradio && (
            <div className={styles.btnGroup}>
              <div className={!finished && cx(styles.buttonGroup)}>

                {presentquestion.id > 0 && finished == false && questionwithradio ? (
                  <button key="Back1" onClick={backanswers}>
                    Back
                  </button>
                ) : null}


                {reviewed == true && !finished && questionwithradio ? (
                  <button key="ConfirmScreen" onClick={confirmanswers}>
                    Confirm
                  </button>
                ) : ""}

              </div>
            </div>)}


          {finished && (
            <div className={cx(styles.summary)}>
              <div className="item">
                <p className="s-title">{totalquestions}</p>
                <p className="sub-title">Question</p>
              </div>
              <div className="item">
                <p style={{ color: '#2ec32b' }} className="s-title">
                  {score}
                </p>
                <p className="sub-title">Correct Answer</p>
              </div>
              <div className="item">
                <p style={{ color: '#c32b2b' }} className="s-title">
                  {totalquestions - score}
                </p>
                <p className="sub-title">Wrong Answer</p>
              </div>
              <div className="item">
                <p style={{ color: '#dd7029' }} className="s-title">
                  {Math.floor((score / totalquestions) * 100)}%
                </p>
                <p className="sub-title">Result</p>
              </div>



            </div>
          )}

          <div className="table-responsive">
            {finished && data1.state['eventtype'] == 'Practice' && (
              <div style={{
                background: '#ffffff',
                borderRadius: '20px',
                border: '1px solid rgba(241, 102, 2, 0.15)',
                boxShadow: '0 10px 30px rgba(0,0,0,0.03)',
                padding: '2rem',
                marginBottom: '30px',
                overflow: 'hidden'
              }}>
                <h3 style={{
                  fontSize: '1.4rem', fontWeight: '800', color: '#382110',
                  marginBottom: '1.5rem', textAlign: 'center', textTransform: 'uppercase', letterSpacing: '0.05em'
                }}>
                  Performance <span style={{ color: '#f16602' }}>Review</span>
                </h3>
                <table
                  border={0}
                  cellPadding={0}
                  cellSpacing={0}
                  className={cx(styles.table)}
                  style={{ width: '100%', borderCollapse: 'collapse', marginBottom: 0 }}
                >
                  <thead>
                    <tr>
                      <th style={{ padding: '15px', background: 'rgba(241,102,2,0.06)', color: '#f16602', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.05em', borderRadius: '12px 0 0 12px' }}>Question</th>
                      <th style={{ padding: '15px', background: 'rgba(241,102,2,0.06)', color: '#f16602', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Correct Answer</th>
                      <th style={{ padding: '15px', background: 'rgba(241,102,2,0.06)', color: '#f16602', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Your Answer</th>
                      <th style={{ padding: '15px', background: 'rgba(241,102,2,0.06)', color: '#f16602', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Result</th>
                      <th style={{ padding: '15px', background: 'rgba(241,102,2,0.06)', color: '#f16602', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.05em', borderRadius: '0 12px 12px 0' }}>Feedback</th>
                    </tr>
                  </thead>
                  <tbody>
                    {questionBank.map(({ question, correctanswer, id, ignorecases, category }, index) => (
                      <CorrectAnswers
                        key={id}
                        question={question}
                        alternateanswers={real_answers[id]}
                        correctanswer={texttospeechwithtextfield ? correctanswer : correctanswer}
                        id={id}
                        selectedanswer={user_answers_right[id] !== undefined ? user_answers_right[id] : ""}
                        eventtype={data1.state['eventdisplay']}
                        ignorecases={ignorecases}
                        category={category}
                        selected={(index) => togglePopupwithId(index)}
                        questionid={index}
                      />
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>


          {presentquestion.id > 0 && finished == false && reviewed == false && imagewithradio ? (
            <ImagewithRadio
              question={presentquestion.question}
              answer={presentquestion.answers}
              imageurl={presentquestion.imageurl}
              id={presentquestion.id}
              key={presentquestion.id}
              selected={(answer) => computeAnswer(answer, presentquestion.id)}
              selectedanswer={user_answers_right1[presentquestion.id]}
              subcategory={presentquestion.subcategory}
              questionnumber={questionnumber}
              questionCount={questionBank.length}
            />
          ) : null}




          {presentquestion.id > 0 && finished == false && reviewed == false && imagewithtextfield ? (
            <ImagewithTextField
              question={presentquestion.question}
              answer={presentquestion.answers}
              imageurl={presentquestion.imageurl}
              id={presentquestion.id}
              key={presentquestion.id}
              selected={(answer) => computeAnswer(answer, presentquestion.id)}
              selectedanswer={user_answers_right[presentquestion.id]}
              subcategory={presentquestion.subcategory}
              questionnumber={questionnumber}
              questionCount={questionBank.length}
            />
          ) : null}



          {presentquestion.id > 0 && finished == false && reviewed == false && mapwithradiobuttons ? (
            <MapwithRadio
              question={presentquestion.question}
              answer={presentquestion.answers}
              id={presentquestion.id}
              key={presentquestion.id}
              questionnumber={questionnumber}
              questionCount={questionBank.length}
              correctanswer={presentquestion.correctanswer}
              selected={(answer) => computeAnswer(answer, presentquestion.id)}
              selectedanswer={user_answers_right[presentquestion.id]}
              scale={presentquestion.scale}
              xaxis={presentquestion.xaxis}
              rotation={presentquestion.rotation}

            />
          ) : null}




          {presentquestion.id > 0 &&
            finished == false && reviewed == false &&
            texttospeechwithtextfield ? (
            <TexttoSpeechwithTextfield
              question={presentquestion.question}
              answer={presentquestion.answers}
              id={presentquestion.id}
              key={presentquestion.id}
              selected={(answer) => computeAnswer(answer, presentquestion.id)}
              selectedanswer={user_answers_right[presentquestion.id]}
              subcategory={presentquestion.subcategory}
              questionnumber={questionnumber}
              nextbutton={selectedanswers}
              meaning={presentquestion.meaning}
              questionCount={totalquestions}
              category={presentquestion.category}
              specific_category={presentquestion.specificcategory}
              audio={presentquestion.audio}
              example={presentquestion.example}
              word_to_pronounce={presentquestion.correctanswer}

            />
          ) : null}

          {presentquestion.id > 0 && finished == false && reviewed == false &&
            listenspeech ? (
            <ListenSpeech
              question={presentquestion.question}
              answer={presentquestion.answers}
              id={presentquestion.id}
              key={presentquestion.id}
              selected={(answer) => computeAnswer(answer, presentquestion.id)}
              selectedanswer={user_answers_right[presentquestion.id]}
              subcategory={presentquestion.subcategory}
              questionnumber={questionnumber}
              nextbutton={selectedanswers}
              meaning={presentquestion.meaning}
              questionCount={totalquestions}
              category={presentquestion.category}
              specific_category={presentquestion.specificcategory}
              audio={presentquestion.audio}
              example={presentquestion.example}

            />
          ) : null}


          {presentquestion.id > 0 &&
            finished == false && reviewed == false &&
            texttospeechwithradiobutton ? (
            <TexttoSpeechwithRadioButton
              question={presentquestion.question}
              answer={presentquestion.answers}
              id={presentquestion.id}
              key={presentquestion.id}
              selected={(answer) => computeAnswer(answer, presentquestion.id)}
              selectedanswer={user_answers_right[presentquestion.id]}
              subcategory={presentquestion.subcategory}
              questionnumber={questionnumber}
              nextbutton={selectedanswers}
              meaning={presentquestion.meaning}
              questionCount={totalquestions}
              category={presentquestion.category}
              specific_category={presentquestion.specificcategory}
              audio={presentquestion.audio}
              word_to_pronounce={presentquestion.correctanswer}

            />
          ) : null}



          {presentquestion.id > 0 &&
            finished == false && reviewed == false &&
            questionwithtextfield ? (
            <QuestionswithTextField
              question={presentquestion.question}
              answer={presentquestion.answers}
              id={presentquestion.id}
              key={presentquestion.id}
              note={presentquestion.extranote}
              selected={(answer) => computeAnswer(answer, presentquestion.id)}
              selectedanswer={user_answers_right[presentquestion.id]}
              subcategory={presentquestion.question}
              questionnumber={questionnumber}
              nextbutton={selectedanswers}
              questionCount={totalquestions}
            />
          ) : null}


          {/* { presentquestion.id>0 && finished == false &&  is_drawquestions ?(<DrawShapeswithTextField question={presentquestion.question} answer={presentquestion.answers} id={presentquestion.id} key={presentquestion.id} selected={answer => computeAnswer(answer,presentquestion.id)} selectedanswer = {user_answers_right[presentquestion.id]}  subcategory = {presentquestion.subcategory} questionnumber = {questionnumber} nextbutton = { selectedanswers} />):null} */}

          {presentquestion.id > 0 && finished == false && questionwithradio && reviewed == false ? (
            <NewQuestionBox
              question={presentquestion.question}
              questionCount={totalquestions}
              questionnumber={questionnumber}
              answer={presentquestion.answers}
              id={presentquestion.id}
              // questionnumber={questionnumber}
              key={presentquestion.id}
              selected={(answer) => computeAnswer(answer, presentquestion.id)}
              selectedanswer1={user_answers_right1[presentquestion.id]}
              category={data1.state['category']}
              controlButtons={controlButtons}
            />

          ) : null}



          {presentquestion.id > 0 && finished == false && questionwithimages && reviewed == false ? (
            <ImagesasOptions
              question={presentquestion.question}
              questionCount={totalquestions}
              questionnumber={questionnumber}
              answer={presentquestion.answers}
              id={presentquestion.id}
              // questionnumber={questionnumber}
              key={presentquestion.id}
              selected={(answer) => computeAnswer(answer, presentquestion.id)}
              selectedanswer1={user_answers_right1[presentquestion.id]}
              category={data1.state['category']}
              controlButtons={controlButtons}
            />
          ) : null}


          {!questionwithradio && controlButtons}

          {presentquestion.id <= 0 ? (
            <div>
              <Lottie options={defaultOptions} height={400} width={400} />
            </div>
          ) : (
            ''
          )}

          <div className={styles.btnGroup}>

            {finished &&
              score < totalquestions &&
              (questionwithradio || texttospeechwithtextfield || texttospeechwithradiobutton || questionwithtextfield) ? (
              <div>
                <button
                  className={cx(button)}
                  onClick={() => playagain(false, true)}
                  disabled={isLoadingMistakes || (!isPremiumUser && hasUsedCorrectMistakes)} 
                  title={!isPremiumUser && hasUsedCorrectMistakes ? "Upgrade to premium to use this feature multiple times" : "Review and correct your missed words"}
                >
                  {isLoadingMistakes ? 'Loading...' : 'REVIEW MISSED WORDS'}
                </button>
              </div>
            ) : null}

            {finished && data1.state['eventtype'] != 'Assignments' && (
              <div>
                <Link
                  to={{
                    pathname: '/practiceevents',
                    state: data1.state['category'],
                  }}
                >
                  <button className={cx(button)}>Next Event</button>
                </Link>
              </div>
            )}

            {finished && data1.state['eventtype'] == 'Assignments' ? (
              <div>
                <Link
                  to={{ pathname: '/practice', state: data1.state['category'] }}
                >
                  <button className={cx(button)}> Next Event </button>
                </Link>
              </div>
            ) : (
              ''
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
export default PracticeQuiz;